import { useFormikEffect } from './useFormikEffect';
import { usePortDetails } from './usePortDetails';

export const usePortPrefetching = (name) => {
    const { prefetch } = usePortDetails();

    useFormikEffect(prefetch, name);
};
